// Pure transformation behind useReformattedSchedules. Kept dependency-free (no
// React / context / models) so it can be unit-tested in isolation.
//
// The server (Api::ShootingScheduleResource#bookable_timeslots, option-aware) has
// ALREADY span-checked which start-times this sitting can be booked at, using the
// single source of truth (AppointmentAvailability). So here we only group those
// bookable start-times into a { shootingDay -> [timeslot, ...] } map, adding the
// "@ Shoob" suffix for the Shoob-studio school (1075). No capacity / span / stride
// logic lives on the client anymore — that was the source of the "offered then
// rejected" bug, where a long sitting was offered at a start whose later blocks
// were full.
const reformatSchedules = (schedules, currentSchoolId) => {
  if (schedules.some((schedule) => !schedule.bookableTimeslots)) return {}

  const shootingDays = [...new Set(schedules.map((schedule) => {
    if (schedule.schoolId === 1075) return `${schedule.shootingDay} @ Shoob`

    return schedule.shootingDay;
  }))]

  const daysToTimes = shootingDays.map((shootingDay) => {
    const times = schedules
      .filter((schedule) => {
        if (shootingDay.includes('@ Shoob')) {
          return schedule.shootingDay === shootingDay.split('@')[0].trim() && schedule.schoolId === 1075
        }

        return schedule.shootingDay === shootingDay && schedule.schoolId === parseInt(currentSchoolId.toString(), 10)
      })
      .map((schedule) => schedule.bookableTimeslots)
      .flat()

    return [shootingDay, times]
  })

  return Object.fromEntries(daysToTimes)
}

export default reformatSchedules
